import { LightbulbAlertIcon } from './LightbulbAlertIcon';

/**
 * author: Michael Irigoyen
 * id 1FED2710-D8D6-41FC-9318-51A23EDD13CF
 * name lightbulb-alert
 * version: 6.6.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/lightbulb-alert.svg
 * tags
 * - Home Automation 
 * - Alert / Error 
 */
export const LightbulbErrorIcon = LightbulbAlertIcon;
export default LightbulbErrorIcon